import { z } from "zod";

// ── Routes 32-33: POST /api/agents/link-fixer/run|apply ──────────

/**
 * Wire-level response for POST /api/agents/link-fixer/run and
 * POST /api/agents/link-fixer/apply.
 * Both routes return the Temporal workflow handle with the same
 * envelope shape.
 */
export const AgentRunResponse = z.object({
  workflow_id: z.string(),
  run_id: z.string(),
  status: z.string(),
});
export type AgentRunResponse = z.infer<typeof AgentRunResponse>;
